import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { StageMergeData } from './stage.merge.data';
import { StageItemMergeData } from './stage.items.merge.data';
import { AssetMergeData } from './asset.merge.data';
import { ContactLinkMergeData } from './contact.link.merge.data';

@MergeSchema({
    entity: ActivityEntityName.ContactLink,
})
export class JobContactLinksMergeData {
    @MergeField({
        arraySchemaName: 'ContactLinkMergeSchema'
    })
    contacts: ContactLinkMergeData[] = [];
}

export const JobContactLinksMergeSchema = getSchema(JobContactLinksMergeData)